import React from 'react'

/**
 * A hook that provides `getColumnSearchProps(dataIndex, getValueFn, placeholder)`
 * for building antd Table column search dropdowns.
 *
 * @param {string[]} columnKeys - The dataIndex keys that will need search inputs.
 */
export function useColumnSearch(columnKeys) {
  // Create stable refs for all column search inputs (only initialised once on mount)
  const searchInputRefs = React.useRef(
    Object.fromEntries(columnKeys.map((key) => [key, React.createRef()])),
  )

  const getColumnSearchProps = (
    dataIndex,
    getValueFn,
    placeholder = 'Search',
  ) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <div style={{ padding: 8 }}>
        <input
          ref={searchInputRefs.current[dataIndex]}
          placeholder={placeholder}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => {
            confirm()
          }}
          style={{ marginBottom: 8, display: 'block', width: 188 }}
        />
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => confirm()} style={{ width: 90 }}>
            Search
          </button>
          <button
            onClick={() => {
              clearFilters?.()
              confirm({ closeDropdown: false })
            }}
            style={{ width: 90 }}
          >
            Reset
          </button>
          <button onClick={() => close()}>Close</button>
        </div>
      </div>
    ),
    filterIcon: (filtered) => (
      <span
        role="img"
        aria-label="search"
        style={{ color: filtered ? '#1890ff' : undefined }}
      >
        🔍
      </span>
    ),
    onFilter: (value, record) => {
      const val = getValueFn(record) || ''
      return val.toString().toLowerCase().includes(value.toLowerCase())
    },
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(
          () => searchInputRefs.current[dataIndex]?.current?.select(),
          100,
        )
      }
    },
    render: (text, record) => getValueFn(record),
  })

  return { getColumnSearchProps }
}
